


 <div id="main">
    <app-loader-animation></app-loader-animation>
 </div>